const messages = {
  'zh-CN': {
    title: '滴滴套餐，单单省钱',
    content: '超低价买多张出行券折扣包，享受乘车优惠',
    desc: '',
    descGoods: '',
    descShare: '',
  },
  'en-US': {
    title: 'DiDi Combo helps you save more on every trip',
    content: 'Save more on trips with super low-priced coupon pack',
    desc: 'Special offer from DiDi',
    descGoods: 'Check out this special offer!',
    descShare: 'Join me in getting this special DiDi offer',
  },
  'zh-HK': {
    title: '滴滴套餐，單單省錢',
    content: '超低價買多張優惠券折扣，享受乘車優惠',
    desc: '',
    descGoods: '',
    descShare: '',
  },
  'ko-KR': {
    title: 'DiDi 패키지, 매차 혜택',
    content: '초저가로 여러 장의 이동 쿠폰 할인팩 구매, 차량 이용 혜택 누리기',
    desc: 'DiDi 특별 혜택입니다',
    descGoods: '이 특별 혜택 확인해 보세요',
    descShare: '함께 DiDi 특별 혜택 받아요',
  },
}

module.exports = messages
